module.exports = __webpack_public_path__ + "static/media/Voyager-RE-4400-IQ.9305e2f3.png";